import { LegacyCard, Page } from '@shopify/polaris';
import { useContext, useRef } from 'react';
import { useParams } from 'react-router';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { signUp } from '../../../services/userService';
import ListUsers from '../../UI/Users/ListUsers';
import { NewUserModal } from '../../UI/Users/NewUserModal';

const Users = () => {
  const { page } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const listUser = useRef();

  const createNewUser = (signUpForm) => {
    return signUp(signUpForm)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        listUser.current.last({ new: true });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };

  return <>
    <Page title="Usuarios" primaryAction={<NewUserModal onAddUser={(e) => createNewUser(e)} />} divider>
      <LegacyCard>
        <ListUsers ref={listUser} page={page || 1} />
      </LegacyCard>
    </Page>
  </>;
};

export default Users;
